'use strict';

var dialog = require("_core_ext/dialog");
var JSConstants = require('_core_ext/pages/search/constants');
// eslint-disable-next-line no-unused-vars
var moduleParams = {};

function initBackInStock() {
    $(document).on('click', JSConstants.CLASS_NOTIFY_ME_TILE, function (e) {
        e.preventDefault();

        var $btn = $(e.target);

        $(document).trigger('product.notifyMePopup', [$btn]);

        dialog.open({
            url: $btn.data('href'),
            options: {
                dialogClass: 'm-back_in_stock'
            },
            callback: function () {
                $(JSConstants.CLASS_BACKINSTOCK_CLOSE).one('click', function () {
                    dialog.close();
                });

                const $form = $('form[id="backInStock"]');

                $form.on('submit', function (e) {
                    if (!$form.valid()) {
                        return false;
                    }

                    e.preventDefault();
                    $(document).trigger('product.notifyMeSubmitted', [$btn]);

                    var data = $(this).serialize();

                    $.ajax({
                        type: "POST",
                        url: $(this).attr("action"),
                        data: data,
                    }).done(function (response) {
                        if (response && response.success) {
                            $(JSConstants.CLASS_BACKINSTOCK_EMAIL).text(response.email);
                            $(JSConstants.CLASS_BACKINSTOCK_SUCCESS_MSG).removeClass('hidden');
                            $(JSConstants.CLASS_BACKINSTOCK_CATEGORY_LINK).removeClass('hidden');
                            $(JSConstants.CLASS_BACKINSTOCK_CLOSE).removeClass('hidden');
                            $(JSConstants.CLASS_BACKINSTOCK_FORM).addClass('hidden');
                            $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).addClass('hidden');
                            $(JSConstants.CLASS_BACKINSTOCK_TITLE_DEFAULT).addClass('hidden');
                            $(JSConstants.CLASS_BACKINSTOCK_TITLE_SUCCESS).removeClass('hidden');
                        } else if (response && response.errorMsg) {
                            $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).text(response.errorMsg);
                            $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).removeClass('hidden');
                        } else {
                            $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).text(Resources.SERVER_ERROR);
                            $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).removeClass('hidden');
                        }
                    }).fail(function() {
                        $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).text(Resources.BAD_RESPONSE);
                        $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).removeClass('hidden');
                    });
                });
            }
        });
    });
}

exports.init = function (params) {
    var $tiles = $('.js-tile_container .js-tile');
    moduleParams = params || {};
    if ($tiles.length === 0) {
        return;
    }
};

exports.initBackInStock = initBackInStock;
